<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 180.15123 117.95613"
    preserveAspectRatio="xMidYMid meet"
    :width="width"
    :height="height"
  >
    <defs>
      <!-- Base gradients: color1→color2 and color2→color1 -->
      <linearGradient :id="`hi-ab-${uid}`">
        <stop :stop-color="color1" offset="0" />
        <stop :stop-color="color2" offset="1" />
      </linearGradient>
      <linearGradient :id="`hi-ba-${uid}`">
        <stop :stop-color="color2" offset="0" />
        <stop :stop-color="color1" offset="1" />
      </linearGradient>

      <!-- Applied gradients for left arcs -->
      <linearGradient
        :href="`#hi-ab-${uid}`"
        :id="`hi-ll-${uid}`"
        x1="66.775009" y1="103.56512" x2="72.15052" y2="103.78316"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        :href="`#hi-ab-${uid}`"
        :id="`hi-lo-${uid}`"
        x1="59.419106" y1="103.79061" x2="75.189651" y2="104.05236"
        gradientUnits="userSpaceOnUse"
      />

      <!-- Applied gradients for right arcs (mirrored) -->
      <linearGradient
        :href="`#hi-ba-${uid}`"
        :id="`hi-rl-${uid}`"
        x1="66.775009" y1="103.56512" x2="72.15052" y2="103.78316"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-1,0,0,1,191.28747,-56.927464)"
      />
      <linearGradient
        :href="`#hi-ba-${uid}`"
        :id="`hi-ro-${uid}`"
        x1="59.419106" y1="103.79061" x2="75.189651" y2="104.05236"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-1,0,0,1,191.28747,-56.927464)"
      />
    </defs>

    <!-- Left head silhouette -->
    <g transform="translate(-13.12,-9.9406502)">
      <path
        :fill="color1"
        d="m 53.36,127.35 c -0.9,-0.47 -1.19,-1.11 -1.42,-3.29 -0.28,-2.52 -0.56,-3.88 -1.2,-5.81 -0.43,-1.3 -1.42,-3.41 -1.6,-3.41 -0.03,0 -0.68,0.13 -1.44,0.28 -4.46,0.92 -6.27,1.11 -10.21,1.13 -3.16,0 -3.93,-0.04 -4.71,-0.25 -4.1,-1.14 -6.64,-3.36 -7.81,-6.86 -0.55,-1.62 -0.65,-3.59 -0.31,-5.99 l 0.27,-1.79 -0.67,-0.76 c -1.19,-1.36 -1.69,-2.89 -1.54,-4.64 0.07,-0.76 0.03,-0.95 -0.27,-1.33 -0.68,-0.92 -0.86,-1.47 -0.92,-2.83 -0.06,-1.1 0,-1.59 0.3,-2.74 0.25,-0.9 0.33,-1.44 0.22,-1.5 -0.07,-0.04 -0.67,-0.13 -1.3,-0.19 -3.59,-0.3 -5.97,-1.7 -7.16,-4.19 -0.46,-0.96 -0.47,-1.08 -0.47,-2.79 0.01,-1.59 0.06,-1.9 0.41,-2.82 0.52,-1.3 2.22,-4.39 5.23,-9.42 3.88,-6.51 4,-6.82 3.54,-9.42 -0.36,-2.02 -0.47,-6.99 -0.22,-9.14 0.56,-4.86 2.42,-10.79 4.74,-15.16 3.25,-6.08 7.99,-11.38 13.71,-15.32 4.92,-3.39 11.19,-6.11 17.56,-7.6 6.89,-1.62 15.59,-2.02 23.12,-1.04 9.72,1.26 18.98,5.11 26.13,10.86 5.08,4.1 9.11,9.13 11.96,14.91 3.23,6.55 4.59,12.51 4.59,20.02 0,4.86 -0.36,7.91 -1.41,12.18 -0.89,3.6 -1.93,6.36 -3.84,10.28 -1.64,3.35 -3.82,6.85 -6.92,11.08 -3.38,4.62 -4.64,7.07 -5.44,10.43 -0.33,1.42 -0.39,1.99 -0.39,4.16 -0.01,2.67 0.12,3.87 0.82,7.34 0.44,2.22 1.72,7.17 2.59,10.03 0.39,1.26 0.5,1.94 0.5,2.79 0,1.36 -0.24,1.97 -0.98,2.53 -0.5,0.39 -0.67,0.43 -1.75,0.43 -1.42,0 -2.15,-0.36 -2.59,-1.24 -0.5,-1.01 -2.82,-9.72 -3.56,-13.43 -1.08,-5.41 -1.17,-10.17 -0.3,-14.27 0.9,-4.15 2.4,-7.13 6.39,-12.71 3.33,-4.67 4.58,-6.64 6.22,-9.84 3.76,-7.32 5.56,-15.69 4.86,-22.69 -0.49,-4.86 -1.73,-9.35 -3.76,-13.54 -1.81,-3.73 -3.79,-6.7 -6.45,-9.63 C 102.75,24.48 95.48,20.07 87.49,17.74 80.64,15.75 73.44,15.13 66.52,15.95 55.51,17.22 46.28,21.24 39.49,27.72 33.93,33.01 29.84,40.36 28.3,47.8 c -0.86,4.1 -0.92,6.05 -0.31,9.54 0.4,2.28 0.4,4.76 -0.01,6.24 -0.31,1.16 -1.41,3.36 -2.87,5.78 -2.76,4.56 -5.6,9.42 -6.03,10.3 l -0.34,0.7 0.55,0.49 c 0.67,0.61 1.59,0.9 3.57,1.11 3.35,0.36 4.7,1.07 5.28,2.8 0.3,0.9 0.21,3.08 -0.22,4.76 l -0.39,1.51 0.37,0.4 c 0.71,0.76 1.04,1.63 1.05,2.83 0.01,0.61 -0.03,1.32 -0.09,1.59 -0.09,0.4 -0.03,0.56 0.43,1.11 0.3,0.36 0.71,1.01 0.92,1.45 0.5,1.1 0.59,3.19 0.24,5.51 -0.3,1.91 -0.24,2.64 0.3,3.67 1.02,2.03 3.26,3.11 6.37,3.11 4.19,0 15.65,-2.19 20.94,-4.03 5.28,-1.81 8.68,-4.68 9.97,-8.37 0.74,-2.09 1.19,-2.47 2.95,-2.53 1.13,-0.04 1.32,-0.01 1.78,0.3 1.19,0.8 1.5,2.47 0.82,4.5 -1.5,4.48 -4.99,7.97 -10.3,10.37 -1.84,0.82 -4.71,1.79 -6.52,2.21 -0.61,0.13 -1.19,0.27 -1.29,0.3 -0.12,0.04 -0.01,0.44 0.33,1.29 1.54,3.84 2.43,10 1.64,11.57 -0.46,0.92 -1.01,1.22 -2.39,1.26 -0.89,0.03 -1.3,-0.03 -1.69,-0.21 z"
      />
    </g>

    <!-- Right head silhouette (same path, mirrored via group transform) -->
    <g transform="matrix(-1,0,0,1,193.27124,-9.6212352)">
      <path
        :fill="color2"
        d="m 53.36,127.35 c -0.9,-0.47 -1.19,-1.11 -1.42,-3.29 -0.28,-2.52 -0.56,-3.88 -1.2,-5.81 -0.43,-1.3 -1.42,-3.41 -1.6,-3.41 -0.03,0 -0.68,0.13 -1.44,0.28 -4.46,0.92 -6.27,1.11 -10.21,1.13 -3.16,0 -3.93,-0.04 -4.71,-0.25 -4.1,-1.14 -6.64,-3.36 -7.81,-6.86 -0.55,-1.62 -0.65,-3.59 -0.31,-5.99 l 0.27,-1.79 -0.67,-0.76 c -1.19,-1.36 -1.69,-2.89 -1.54,-4.64 0.07,-0.76 0.03,-0.95 -0.27,-1.33 -0.68,-0.92 -0.86,-1.47 -0.92,-2.83 -0.06,-1.1 0,-1.59 0.3,-2.74 0.25,-0.9 0.33,-1.44 0.22,-1.5 -0.07,-0.04 -0.67,-0.13 -1.3,-0.19 -3.59,-0.3 -5.97,-1.7 -7.16,-4.19 -0.46,-0.96 -0.47,-1.08 -0.47,-2.79 0.01,-1.59 0.06,-1.9 0.41,-2.82 0.52,-1.3 2.22,-4.39 5.23,-9.42 3.88,-6.51 4,-6.82 3.54,-9.42 -0.36,-2.02 -0.47,-6.99 -0.22,-9.14 0.56,-4.86 2.42,-10.79 4.74,-15.16 3.25,-6.08 7.99,-11.38 13.71,-15.32 4.92,-3.39 11.19,-6.11 17.56,-7.6 6.89,-1.62 15.59,-2.02 23.12,-1.04 9.72,1.26 18.98,5.11 26.13,10.86 5.08,4.1 9.11,9.13 11.96,14.91 3.23,6.55 4.59,12.51 4.59,20.02 0,4.86 -0.36,7.91 -1.41,12.18 -0.89,3.6 -1.93,6.36 -3.84,10.28 -1.64,3.35 -3.82,6.85 -6.92,11.08 -3.38,4.62 -4.64,7.07 -5.44,10.43 -0.33,1.42 -0.39,1.99 -0.39,4.16 -0.01,2.67 0.12,3.87 0.82,7.34 0.44,2.22 1.72,7.17 2.59,10.03 0.39,1.26 0.5,1.94 0.5,2.79 0,1.36 -0.24,1.97 -0.98,2.53 -0.5,0.39 -0.67,0.43 -1.75,0.43 -1.42,0 -2.15,-0.36 -2.59,-1.24 -0.5,-1.01 -2.82,-9.72 -3.56,-13.43 -1.08,-5.41 -1.17,-10.17 -0.3,-14.27 0.9,-4.15 2.4,-7.13 6.39,-12.71 3.33,-4.67 4.58,-6.64 6.22,-9.84 3.76,-7.32 5.56,-15.69 4.86,-22.69 -0.49,-4.86 -1.73,-9.35 -3.76,-13.54 -1.81,-3.73 -3.79,-6.7 -6.45,-9.63 C 102.75,24.48 95.48,20.07 87.49,17.74 80.64,15.75 73.44,15.13 66.52,15.95 55.51,17.22 46.28,21.24 39.49,27.72 33.93,33.01 29.84,40.36 28.3,47.8 c -0.86,4.1 -0.92,6.05 -0.31,9.54 0.4,2.28 0.4,4.76 -0.01,6.24 -0.31,1.16 -1.41,3.36 -2.87,5.78 -2.76,4.56 -5.6,9.42 -6.03,10.3 l -0.34,0.7 0.55,0.49 c 0.67,0.61 1.59,0.9 3.57,1.11 3.35,0.36 4.7,1.07 5.28,2.8 0.3,0.9 0.21,3.08 -0.22,4.76 l -0.39,1.51 0.37,0.4 c 0.71,0.76 1.04,1.63 1.05,2.83 0.01,0.61 -0.03,1.32 -0.09,1.59 -0.09,0.4 -0.03,0.56 0.43,1.11 0.3,0.36 0.71,1.01 0.92,1.45 0.5,1.1 0.59,3.19 0.24,5.51 -0.3,1.91 -0.24,2.64 0.3,3.67 1.02,2.03 3.26,3.11 6.37,3.11 4.19,0 15.65,-2.19 20.94,-4.03 5.28,-1.81 8.68,-4.68 9.97,-8.37 0.74,-2.09 1.19,-2.47 2.95,-2.53 1.13,-0.04 1.32,-0.01 1.78,0.3 1.19,0.8 1.5,2.47 0.82,4.5 -1.5,4.48 -4.99,7.97 -10.3,10.37 -1.84,0.82 -4.71,1.79 -6.52,2.21 -0.61,0.13 -1.19,0.27 -1.29,0.3 -0.12,0.04 -0.01,0.44 0.33,1.29 1.54,3.84 2.43,10 1.64,11.57 -0.46,0.92 -1.01,1.22 -2.39,1.26 -0.89,0.03 -1.3,-0.03 -1.69,-0.21 z"
      />
    </g>

    <!-- Left arc strokes (4 arcs, inside-out, gradient then solid) -->
    <g transform="translate(-11.046113,-56.927464)">
      <path
        fill="none"
        :stroke="`url(#hi-ll-${uid})`"
        stroke-width="2.4" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
        d="m 75.275331,82.449485 c -9.355947,11.97147 -9.867527,28.876995 -0.71917,42.294175"
      />
      <path
        fill="none"
        :stroke="color2"
        stroke-width="2.4" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
        d="m 78.911632,88.849485 c -5.360129,9.032213 -5.721557,18.018855 -0.71917,29.494175"
      />
      <path
        fill="none"
        :stroke="`url(#hi-lo-${uid})`"
        stroke-width="2.64203" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
        d="M 69.704539,77.522577 C 58.215411,92.271827 57.525675,113.27645 69.003818,130.12673"
      />
      <path
        fill="none"
        :stroke="color1"
        stroke-width="2.88063" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
        d="M 61.227387,72.461376 C 49.350762,89.945689 48.630759,115.41897 60.540455,136.25107"
      />
    </g>

    <!-- Right arc strokes (4 arcs, mirrored) -->
    <path
      fill="none"
      :stroke="`url(#hi-rl-${uid})`"
      stroke-width="2.4" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
      d="m 116.01214,25.522021 c 9.35595,11.97147 9.86753,28.876995 0.71917,42.294175"
    />
    <path
      fill="none"
      :stroke="color1"
      stroke-width="2.4" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
      d="m 112.37584,31.922021 c 5.36013,9.032213 5.72155,18.018855 0.71917,29.494175"
    />
    <path
      fill="none"
      :stroke="`url(#hi-ro-${uid})`"
      stroke-width="2.64203" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
      d="m 121.58293,20.595113 c 11.48913,14.74925 12.17886,35.753873 0.70072,52.604153"
    />
    <path
      fill="none"
      :stroke="color2"
      stroke-width="2.88063" stroke-linecap="butt" stroke-linejoin="miter" stroke-dasharray="none" stroke-opacity="1"
      d="m 130.06008,15.533912 c 11.87663,17.484313 12.59663,42.957594 0.68693,63.789694"
    />
  </svg>
</template>

<script>
/**
 * SVG head-pair icon derived from docs/design/head.svg.
 * Renders two mirrored head silhouettes with arc strokes, all coloured via props.
 * @prop {String} color1 - Left head colour and base gradient stop (default: cadet blue #5f9ea0)
 * @prop {String} color2 - Right head colour and base gradient stop (default: coral #ff7f50)
 * @prop {String|Number} width  - SVG width attribute; omit to let the container control size
 * @prop {String|Number} height - SVG height attribute; omit to let the container control size
 * @returns SVG element
 */

let _uidCounter = 0

export default {
  name: 'HeadIcon',


  props: {
    color1: { type: String, default: '#5f9ea0' },
    color2: { type: String, default: '#ff7f50' },
    width:  { type: [String, Number], default: undefined },
    height: { type: [String, Number], default: undefined },
  },


  data() {
    return {
      uid: ++_uidCounter,
    }
  },
}
</script>
